import { PageHeader } from '@/components/shared/page-header';
import { TableSkeleton } from '@/components/shared/skeleton';

export function Loading() {
  return (
    <>
      <PageHeader title="User management" description="Assign users to companies and stations" />
      <TableSkeleton columns={6} />
    </>
  );
}
